import { Quote } from "@/models/Quote";
import { formatDateForDateInput } from "@/utils/Utils";
import { useQuoteStore } from "@/stores/root/quote";

function addDaysToCurrentDateFormated(nrOfDays: number) {
  const d = new Date();
  d.setDate(d.getDate() + nrOfDays);

  return formatDateForDateInput(d);
}

function tomorrow() {
  return addDaysToCurrentDateFormated(1);
}

function todayPlusSixty() {
  return addDaysToCurrentDateFormated(60);
}

/**
 * Validates assurant data after it is read from storage.
 */
export function validateAssurant(quote: Quote) {
  // if (quote.info.coverageStartDate) {
  //   if (
  //     +new Date(quote.info.coverageStartDate).setHours(0, 0, 0, 0) <
  //       +new Date(tomorrow()).setHours(0, 0, 0, 0) ||
  //     +new Date(quote.info.coverageStartDate).setHours(0, 0, 0, 0) >
  //       +new Date(todayPlusSixty()).setHours(0, 0, 0, 0)
  //   ) {
  //     // Go back to quote questions
  //     // quote.currentStep = 1;
  //     store.commit("Root/SAVE_STORAGE", quote);
  //   }
  // }
  // These are my changes
  // if (quote.info.coverageStartDate) {
  //   if (
  //     +new Date(quote.info.coverageStartDate).setHours(0, 0, 0, 0) <
  //       +new Date(tomorrow()).setHours(0, 0, 0, 0) ||
  //     +new Date(quote.info.coverageStartDate).setHours(0, 0, 0, 0) >
  //       +new Date(todayPlusSixty()).setHours(0, 0, 0, 0)
  //   ) {
  //     // Go back to quote questions
  //     quote.currentStep = 1;
  //     const quoteStore = useQuoteStore();
  //     //store.commit("Root/SAVE_STORAGE", quote);--------------------
  //     quoteStore.SAVE_STORAGE(quote);
  //   }
  // }
}
